module.exports = __webpack_public_path__ + "img/message-lines-sharp-light.5703c393.svg";